/*
    依赖axios
    依赖kd.js
*/

import axios from 'axios';
//kd
import Kd from '@/assets/js/kd.js';

import GLOBAL from '@/assets/js/global.js';

window.plat_auto_login = document.location.href.indexOf('plat_auto_login') > -1 ? 1 : 0;

window.deviceType = isPC()?'pc':'mobile';

const getQueryVariable = function (variable) {
    var query = window.location.search.substring(1) || window.location.hash.substring(1);
    var vars = query.split("&");

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
        return pair[1];
        }
    }
    return '';
}

const account = getQueryVariable('account') ? getQueryVariable('account') : ''
const session = getQueryVariable('session') ? getQueryVariable('session') : ''

function isPC(){
    var userAgentInfo = navigator.userAgent;
    var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;    
}

const free_login_mplat = function(uid,free_url,callback){
    if(deviceType != 'pc' && !plat_auto_login)return;

    //console.log(free_url);

    //梦平台
    if(plat_auto_login && parseInt(account) && account != uid){
        localStorage.clear();
        window.history.pushState({}, 0, GLOBAL.domain);

        axios.get(free_url,{
            params : {
                AccountId : account,
                SessionId : session,
            }
        })
        .then(res => {
            callback (res.data);     
        },
        rej => {
            callback ();
        })
    }
    else{
        window.history.pushState({}, 0, GLOBAL.domain);
        callback ();
    }
}

const free_login_kd = function(free_url,callback){
    if(deviceType == 'pc')return;
    Kd.freeLogin(free_url,callback); 
}

const free_login_lazy = function(uid,config,callback){
    if(deviceType == 'pc'){
        return free_login_mplat(uid,config.mplat,callback);
    }
    else{
        return free_login_kd(config.kd,callback);
    } 
}

export default{ 
    free_login_mplat,
    free_login_kd,
    free_login_lazy,
 };


// WEBPACK FOOTER //
// ./src/assets/js/freeLogin.js